import React from 'react';
import '../stylesheets/stylesComponents/tag.scss';
import Icon from './Icon';
import Tooltip from './Tooltip';
import useTranslate from '../customHooks/useTranslate';

export const TAG_COLORS = [
    'green',
    'purple',
    'orange',
    'cyan',
    'pink',
    'yellow',
    'red',
    'blue',
    'grey',
] as const;

export type TagColor = (typeof TAG_COLORS)[number];

export type TagSize = 'small' | 'medium' | 'large';

export interface TagProps {
    className?: string;
    text?: string;
    color: TagColor;
    style?: React.CSSProperties;
    variant?: 'contained' | 'outlined' | 'contrast' | 'surface';
    size?: TagSize;
    button?: boolean;
    onClick?: React.MouseEventHandler<HTMLElement>;
    startIcon?: string;
    endIcon?: string;
    iconStyle?: React.CSSProperties;
    iconProps?: Partial<React.ComponentProps<typeof Icon>>;
    titleText?: string;
    uppercase?: boolean;
    rounded?: boolean;
}

const Tag = (props: TagProps) => {
    const {
        className,
        text,
        color,
        style,
        variant = 'contained',
        size = 'medium',
        button = false,
        onClick,
        startIcon,
        endIcon,
        iconStyle,
        iconProps,
        titleText,
        uppercase = false,
        rounded = false,
    } = props;
    const translate = useTranslate();

    const Component = button ? 'button' : 'div';

    return (
        <div>
            <Tooltip titleText={titleText} hideTooltip={!titleText}>
                <Component
                    onClick={onClick}
                    className={`tag__container ${className || ''} ${
                        button ? 'tag__button' : ''
                    } ${uppercase ? 'tag__container--uppercase' : ''} ${
                        rounded ? 'tag__container--rounded' : ''
                    } tag--${color} tag--${variant} tag--${size}`}
                    style={style}
                >
                    {startIcon && (
                        <Icon
                            iconName={startIcon}
                            style={iconStyle}
                            {...iconProps}
                        />
                    )}
                    {translate(text)}
                    {endIcon && (
                        <Icon
                            iconName={endIcon}
                            style={iconStyle}
                            {...iconProps}
                        />
                    )}
                </Component>
            </Tooltip>
        </div>
    );
};

export default Tag;
